import React, { useEffect, useState } from "react";
import { Row, Col } from "react-bootstrap";
import { Tooltip } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { fetchMembershipOverview } from "../../redux/Slices/membershipOverviewSlice";
import Loader from "../../components/Common/Loader";
import ToastNotification from "../../components/Common/ToastNotification";
import useCustomTranslation from "../../hooks/useCustomTranslation";

const MembershipOverview = ({ selectedClientId }) => {
  const dispatch = useDispatch();
  const { duration, type, status, paymentMonthStatus, loading, error } =
    useSelector((state) => state.membershipOverview);

  const { trans } = useCustomTranslation();

  const [toastConfig, setToastConfig] = useState(null);
  const [showToast, setShowToast] = useState(false);

  useEffect(() => {
    const clientId = selectedClientId;
    dispatch(fetchMembershipOverview(clientId));
  }, [dispatch, selectedClientId]);

  const getPaymentBarColor = (status) => {
    switch (status) {
      case "Received":
      case "Success":
        return "#28A745";
      case "Failed":
      case "Cancelled":
        return "#DC3545";
      case "Pending":
      case "Processing":
      case "Next":
        return "#A0A0A0";
      default:
        return "#6C757D";
    }
  };

  useEffect(() => {
    if (error) {
      setToastConfig({
        type: "error",
        message: error,
        heading: trans("Common.failed"),
      });
      setShowToast(true);
    }
  }, [error, trans]);

  return (
    <div>
      <h6>{trans("Common.membership") + " " + trans("Common.overview")}</h6>

      {loading ? (
        <Loader />
      ) : (
        <Row>
          <Col xs={3} sm={3} md={3} lg={3}>
            <p className="ms-1 fs-6 font-normal mb-2 text-color-gray-40">
              {trans("Common.duration")}
            </p>
            <p className="ms-1 fs-6 font-normal">{duration}</p>
          </Col>
          <Col xs={4} sm={4} md={4} lg={4}>
            <p className="ms-1 fs-6 font-normal mb-2 text-color-gray-40">
              {trans("Common.type")}
            </p>
            <p className="ms-1 fs-6 font-normal">{type}</p>
          </Col>
          <Col xs={2} sm={2} md={2} lg={2}>
            <p className="ms-1 fs-6 font-normal mb-2 text-color-gray-40">
              {trans("Common.status")}
            </p>
            <p className="ms-1 fs-6 font-normal">{status}</p>
          </Col>
          <Col xs={3} sm={3} md={3} lg={3}>
            <p className="ms-1 fs-6 font-normal mb-2 text-color-gray-40">
              {trans("Common.payments")}
            </p>
            <div className="payment-bars">
              {paymentMonthStatus?.map((payment, index) => (
                <Tooltip
                  key={index}
                  title={
                    <>
                      {payment.date + "  " + payment.month}
                      <br />
                      Payment {payment.paymentStatus}
                      <br />
                      Amount {payment.amount}
                    </>
                  }
                >
                  <div
                    className="payment-bar"
                    style={{
                      backgroundColor: getPaymentBarColor(
                        payment.paymentStatus
                      ),
                    }}
                  />
                </Tooltip>
              ))}
            </div>
          </Col>
        </Row>
      )}

      {/* Toast Notification */}
      {showToast && toastConfig && (
        <ToastNotification
          type={toastConfig.type}
          message={toastConfig.message}
          heading={toastConfig.heading}
          onClose={() => setShowToast(false)}
        />
      )}
    </div>
  );
};

export default MembershipOverview;
